module.exports = __webpack_public_path__ + "img/nfc.3d5c46c7.svg";